import React from "react";
import "./onboardWelcomeTextMd.scss";
const OnboardWelcomeTextMd = ({ txt }) => {
  return <div className="onboard-welcome-text-md">{txt}</div>;
};

export default OnboardWelcomeTextMd;
